<template>
  <div class="columns is-multiline">

    <div v-for="(revision, index) in revisions" :key="index" class="column is-half-desktop">
      <div class="box">
        <div class="columns is-multiline mb-0">
          <div class="column">
            <InputSelect
              name="Tipologia"
              v-model="revision.type"
              :options="$store.state.revision_types.map(({ name }) => name)"
              :disabled="noEdit"
            />
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Scadenza</label>
              <div class="control">
                <input class="input" type="date" placeholder="Scadenza" v-model="revision.expire" :disabled="noEdit" @focus="setRevisionPreviousExpire(revision)" @change="onRevisionExpireChange(revision)" />
              </div>
              <div v-if="revision._showExpireWarning" class="notification is-warning is-light mt-2 mb-0 py-2">
                Attenzione: la differenza tra le due date e minore di un anno.
              </div>
            </div>
          </div>
          <div class="column">
            <InputSelect
              name="Codice"
              v-model="revision.code"
              :options="codes"
              :disabled="noEdit"
            />
          </div>
          <div class="column is-12">
            Cadenza rcee: 
            <div v-if="revision.code">
              <div v-if="!getRceeYears[revision.code]?.error && getRceeYears[revision.code]?.years">
                {{ getRceeYears[revision.code]?.years }} anni
                <span v-if="calcNextRcee(revision)">(prossimo nel <b>{{calcNextRcee(revision)}}</b>)</span>
              </div>
              <div v-else-if="!getRceeYears[revision.code]?.error && !getRceeYears[revision.code]?.years">Non richiesta</div>
              <div v-else-if="getRceeYears[revision.code]?.error">Errore: tipologie di alimentazione multiple </div>

              <div v-if="getRceeYears[revision.code]?.incomplete">Ci sono {{ getRceeYears[revision.code]?.incomplete }} impianti incompleti</div>
            </div>
            <div v-else>
              <div v-if="!getRceeYears['_nocode'].error && getRceeYears['_nocode'].years">{{ getRceeYears['_nocode'].years }} anni</div>
              <div v-else-if="!getRceeYears['_nocode'].error && !getRceeYears['_nocode'].years">Non richiesta</div>
              <div v-else-if="getRceeYears['_nocode'].error">Errore: tipologie di alimentazione multiple </div>

              <div v-if="getRceeYears['_nocode'].incomplete">Ci sono {{ getRceeYears['_nocode'].incomplete }} impianti incompleti</div>
            </div>
            
          </div>
          <div class="column is-12 pb-0">
            <div class="is-flex is-justify-content-space-between">
              <div class="buttons mb-0">
                <button class="button is-small is-primary mb-0" type="button" title="Aggiungi" @click="openModalRevisionLog(index)" v-if="!noEdit">
                  <font-awesome-icon icon="plus" /> Aggiungi
                </button>
                <button class="button is-small is-info mb-0" type="button" title="Storico" @click="revision.hideHistory = !revision.hideHistory" :disabled="!Array.isArray(revision.log) || revision.log.length === 0">
                  <font-awesome-icon icon="clock-rotate-left" />{{(Array.isArray(revision.log)) ? revision.log.length : 0}}
                </button>
              </div>
              <div class="buttons mb-0" v-if="!operation">
                <button v-if="addOperation && !revision.operation" class="button is-small is-success mb-0" type="button" title="Aggiungi appuntamento" @click="$emit('addAppointment', revision)"><span class="icon"><font-awesome-icon icon="plus" /><font-awesome-icon icon="file-lines" /></span><span class="ml-1">Aggiungi appuntamento</span></button>
                <router-link v-if="revision.operation" :to="'/appuntamenti/' + revision.operation" class="button is-small is-primary mb-0" title="Apri appuntamento" style="margin-right: 0.5rem;"><font-awesome-icon icon="file-lines" class="m-0" /></router-link>
                <button class="button is-small is-danger mb-0" type="button" title="Elimina" @click="revisions.splice(index, 1)">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
              <div class="buttons mb-0" v-else>
                <div class="mr-2" style="min-width: 240px;">
                  <multiselect
                    v-model="selectedSignerByRevision[getSignerKey(revision)]"
                    :options="operatorsWithSignature"
                    placeholder="Firmatario"
                    track-by="_id"
                    :custom-label="$fullname"
                    :allow-empty="true"
                    :show-labels="false"
                  ></multiselect>
                </div>
                
                <div class="dropdown" :class="{'is-active': openDocsDropdown}" @click="openDocsDropdown = !openDocsDropdown">
                  <div class="dropdown-trigger">
                    <button class="button is-small is-primary mb-0" type="button" title="Seleziona modello documento">
                      <span class="icon m-0"><font-awesome-icon icon="file-lines" /></span> Documento
                      <span class="icon is-small">
                        <font-awesome-icon icon="angle-down" />
                      </span>
                    </button>
                  </div>
                  <div class="dropdown-menu" id="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                      <a class="dropdown-item" href="javascript:void(0)" title="Dam" @click="openDoc(revision, 'dam')">
                        Dam
                      </a>
                      <a v-if="isGt(revision.code)" class="dropdown-item" href="javascript:void(0)" title="Rcee GT documento unico" @click="openDoc(revision, 'rcee_gt')">
                        Rcee GT{{ hasMultipleThermalGroups(revision.code) ? ' (unico)' : '' }}
                      </a>
                      <a v-if="isGt(revision.code)" class="dropdown-item" href="javascript:void(0)" title="Rcee GT documento unico" @click="openDoc(revision, 'rcee_gt_bollino')">
                        Rcee GT con bollino{{ hasMultipleThermalGroups(revision.code) ? ' (unico)' : '' }}
                      </a>
                      <a v-if="hasMultipleThermalGroups(revision.code)" class="dropdown-item" href="javascript:void(0)" title="Rcee GT per gruppo termico" @click="openDocPerThermalGroup(revision)">
                        Rcee GT (per gruppo termico)
                      </a>
                      <a v-if="hasMultipleThermalGroups(revision.code)" class="dropdown-item" href="javascript:void(0)" title="Rcee GT per gruppo termico" @click="openDocPerThermalGroup(revision, 'rcee_gt_bollino')">
                        Rcee GT con bollino (per gruppo termico)
                      </a>
                      <a v-if="isGf(revision.code)" class="dropdown-item" href="javascript:void(0)" title="Rcee GF" @click="openDoc(revision, 'rcee_gf')">
                        Rcee GF{{ hasMultiplePumpGroups(revision.code) ? ' (unico)' : '' }}
                      </a>
                      <a v-if="isGf(revision.code)" class="dropdown-item" href="javascript:void(0)" title="Rcee GF con bollino" @click="openDoc(revision, 'rcee_gf_bollino')">
                        Rcee GF con bollino{{ hasMultiplePumpGroups(revision.code) ? ' (unico)' : '' }}
                      </a>
                      <a v-if="hasMultiplePumpGroups(revision.code)" class="dropdown-item" href="javascript:void(0)" title="Rcee GF per gruppo frigo" @click="openDocPerPumpGroup(revision)">
                        Rcee GF (per gruppo frigo)
                      </a>
                      <a v-if="hasMultiplePumpGroups(revision.code)" class="dropdown-item" href="javascript:void(0)" title="Rcee GF per gruppo frigo" @click="openDocPerPumpGroup(revision, 'rcee_gf_bollino')">
                        Rcee GF con bollino (per gruppo frigo)
                      </a>
                      <a v-if="isGt(revision.code)" class="dropdown-item" href="javascript:void(0)" title="Dfm GT" @click="openDoc(revision, 'dfm_gt')">
                        Dfm GT
                      </a>
                      <a v-if="isGf(revision.code)" class="dropdown-item" href="javascript:void(0)" title="Dfm GF" @click="openDoc(revision, 'dfm_gf')">
                        Dfm GF
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!revision.hideHistory">
          <hr />

          <h5 class="title is-5 has-text-centered">Storico</h5 >

          <div class="table-wrapper has-mobile-cards" v-if="revision.log">
            <table class="table is-fullwidth is-striped is-hoverable">
              <thead>
                <tr>
                  <th style="width: 200px;">Data</th>
                  <!--<th style="width: 145px;">Prezzo</th>
                  <th style="width: 100px;">Pagato</th>
                  <th style="width: 100px;">Fatturato</th>-->
                  <th style="width: 145px;">Appuntamento</th>
                  <th style="width: 145px;">Rcee</th>
                  <th>Note</th>
                  <th style="width: 100px;">Allegato</th>
                  <th style="width: 40px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="record in sortRevisionLog(revision.log)" :key="getRecordKey(record)">
                  <td data-label="Data">
                    <input class="input" type="date" placeholder="Data manutenzione" v-model="record.date" />
                    <!--{{record.date ? new Date(record.date).toDisplay() : ''}}-->
                  </td>
                  <!--<td data-label="Prezzo">
                    <input class="input" type="text" placeholder="Prezzo" v-model="record.price" />
                  </td>
                  <td data-label="Pagato">
                    <label class="checkbox">
                      <input type="checkbox" v-model="record.paid">
                    </label>
                  </td>
                  <td data-label="Fatturato">
                    <label class="checkbox">
                      <input type="checkbox" v-model="record.billed">
                    </label>
                  </td>-->
                  <td data-label="Appuntamento">
                    <div v-if="record.operation">
                      <a class="button is-warning" :href="'/appuntamenti/'+record.operation"><font-awesome-icon icon="file-lines" class="m-0" /></a>
                    </div>
                  </td>
                  <td data-label="Rcee">
                    <label class="checkbox">
                      <input type="checkbox" v-model="record.rcee">
                    </label>
                  </td>
                  <td data-label="Note">
                    <textarea class="input" v-model="record.notes"></textarea>
                  </td>
                  <td data-label="Allegato">
                    <div class="buttons is-centered">
                      <button class="button is-small is-info" @click="openEditDocModal(record)" title="Documento">
                        <font-awesome-icon icon="file" />{{(Array.isArray(record.docs)) ? record.docs.length : 0}}
                      </button>
                    </div>
                  </td>
                  <td>
                    <div class="buttons is-right">
                      <button class="button is-small is-danger" @click="deleteRevisionLog(revision, record)" title="Elimina">
                        <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-12" v-if="!operation">
      <div class="is-flex is-justify-content-center is-align-items-center" style="height: 100%">
        <button class="button is-info" type="button" @click="addRevision()"><font-awesome-icon icon="plus" />Aggiungi manutenzione</button>
      </div>
    </div>

    <Modal :title="'Aggiungi manutenzione'" :openModal="openNewRevisionLog" :loading="waitAddRevisionLog" @close="openNewRevisionLog = false" @success="addRevisionLog()">
      <!--<div class="field">
        <label class="label">Prezzo</label>
        <div class="control">
          <input class="input" type="text" placeholder="Prezzo" v-model="newRevisionLog.price" />
        </div>
      </div>
      <div class="field">
        <label class="label">Pagato</label>
        <div class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="newRevisionLog.paid">
          </label>
        </div>
      </div>-->
      <div class="field">
        <label class="label">Data manutenzione</label>
        <div class="control">
          <input class="input" type="date" placeholder="Data manutenzione" v-model="newRevisionLog.date" @input="onRevisionLogDateChange()" />
        </div>
      </div>
      <div class="field">
        <label class="label">Nuova scadenza manutenzione</label>
        <div class="control">
          <input class="input" type="date" placeholder="Nuova scadenza" v-model="newRevisionLog.newExpire" @change="onNewRevisionExpireChange()" />
        </div>
        <div v-if="newRevisionExpireWarning" class="notification is-warning is-light mt-2 mb-0 py-2">
          Attenzione: la differenza tra la scadenza corrente e la nuova scadenza e minore di un anno.
        </div>
      </div>
      <div class="field">
        <label class="label">Bollino Rcee</label>
        <div class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="newRevisionLog.rcee">
          </label>
        </div>
      </div>
      <div class="field">
        <label class="label">Note</label>
        <div class="control">
          <textarea class="textarea" placeholder="Note" v-model="newRevisionLog.notes"></textarea>
        </div>
      </div>

      <div class="field mb-2">
        <label class="label">Allegato revisione</label>
        <div>
          <div class="file has-name mr-2" :class="{'is-info': uploadLabelNewFile !== 'Nessun file selezionato'}" style="min-width: 0; flex: 1 1 0px;">
            <label class="file-label">
              <input class="file-input" type="file" ref="inputNewDocs" multiple @change="updateUploadLabel('new')">
              <span class="file-cta">
                <span class="file-icon"><font-awesome-icon icon="upload" /></span>
                <span class="file-label">Seleziona file</span>
              </span>
              <span class="file-name" :class="{'is-italic': uploadLabelNewFile === 'Nessun file selezionato'}">{{ uploadLabelNewFile }}</span>
            </label>
          </div>
          <div v-if="isMobile" class="file has-name mt-2" :class="{'is-info': uploadLabelNewPhoto !== 'Nessun file selezionato'}" style="min-width: 0; flex: 1 1 0px;">
            <label class="file-label">
              <input class="file-input" type="file" accept="image/*" capture="camera" ref="inputNewPhotoDocs" multiple @change="updateUploadLabel('new')">
              <span class="file-cta">
                <span class="file-icon"><font-awesome-icon icon="camera" /></span>
                <span class="file-label">Scatta foto</span>
              </span>
              <span class="file-name" :class="{'is-italic': uploadLabelNewPhoto === 'Nessun file selezionato'}">{{ uploadLabelNewPhoto }}</span>
            </label>
          </div>
        </div>
      </div>
    </Modal>

    <Modal :title="'Allegati revisione'" :openModal="openEditRevisionDocs" @close="openEditRevisionDocs = false" noAction>
      <div class="field mb-3">
        <div>
          <div class="file has-name mr-2" :class="{'is-info': uploadLabelEditFile !== 'Nessun file selezionato'}" style="min-width: 0; flex: 1 1 0px;">
            <label class="file-label">
              <input class="file-input" type="file" ref="inputEditDocs" multiple @change="updateUploadLabel('edit')" :disabled="waitUploadEditDoc">
              <span class="file-cta">
                <span class="file-icon"><font-awesome-icon icon="upload" /></span>
                <span class="file-label">Seleziona file</span>
              </span>
              <span class="file-name" :class="{'is-italic': uploadLabelEditFile === 'Nessun file selezionato'}">{{ uploadLabelEditFile }}</span>
            </label>
          </div>
          <div v-if="isMobile" class="file has-name mt-2" :class="{'is-info': uploadLabelEditPhoto !== 'Nessun file selezionato'}" style="min-width: 0; flex: 1 1 0px;">
            <label class="file-label">
              <input class="file-input" type="file" accept="image/*" capture="camera" ref="inputEditPhotoDocs" multiple @change="updateUploadLabel('edit')" :disabled="waitUploadEditDoc">
              <span class="file-cta">
                <span class="file-icon"><font-awesome-icon icon="camera" /></span>
                <span class="file-label">Scatta foto</span>
              </span>
              <span class="file-name" :class="{'is-italic': uploadLabelEditPhoto === 'Nessun file selezionato'}">{{ uploadLabelEditPhoto }}</span>
            </label>
          </div>
        </div>
        <button class="button is-primary mt-2" type="button" :disabled="disabledUploadEditDoc || waitUploadEditDoc" :class="{'is-loading': waitUploadEditDoc}" @click="uploadEditDocs()">Carica</button>
      </div>

      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped" style="table-layout: fixed;">
          <thead>
            <tr>
              <th style="width: 180px;">Nome</th>
              <th style="width: 140px;">Utente</th>
              <th style="width: 140px;">Data</th>
              <th style="width: 110px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!Array.isArray(editRecord.docs) || editRecord.docs.length === 0">
              <td colspan="100"><i>Nessun allegato</i></td>
            </tr>
            <tr v-for="(doc, docIndex) in (Array.isArray(editRecord.docs) ? editRecord.docs : [])" :key="doc.url + '-' + docIndex">
              <td data-label="Nome" style="overflow: hidden; text-overflow: ellipsis;">
                <a :href="baseUrl + '/uploads/' + doc.url" target="_blank">{{ doc.name || doc.url }}</a>
              </td>
              <td data-label="Utente">
                <span class="is-size-7">{{ formatDocUser(doc) }}</span>
              </td>
              <td data-label="Data">
                {{ doc.createdAt ? new Date(doc.createdAt).toDisplay(true) : '' }}
              </td>
              <td class="is-actions-cell is-justify-content-flex-end">
                <div class="buttons is-right">
                  <button class="button is-warning" type="button" @click="editDocName(doc)" title="Rinomina"><span class="icon"><font-awesome-icon icon="pen" /></span></button>
                  <button class="button is-danger" type="button" @click="deleteDoc(editRecord, docIndex)" title="Elimina"><span class="icon"><font-awesome-icon icon="trash-can" /></span></button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>

  </div>
</template>

<script>
import rcee from '../rcee.js'
import Compressor from 'compressorjs'

export default {
  props: ['revisions', 'isDoc', 'operation', 'addOperation', 'noEdit', 'codes', 'implant'],

  emits: ['addLog', 'addAppointment'],
  
  data() {
    return {
      newRevisionLog: {},
      editRecord: {},

      openNewRevisionLog: false,
      openEditRevisionDocs: false,

      openDocsDropdown: false,
      revisionLogKeys: new WeakMap(),
      revisionLogKeyCounter: 0,

      baseUrl: import.meta.env.VITE_SERVER,
      isMobile: false,

      uploadLabelNewFile: 'Nessun file selezionato',
      uploadLabelNewPhoto: 'Nessun file selezionato',

      uploadLabelEditFile: 'Nessun file selezionato',
      uploadLabelEditPhoto: 'Nessun file selezionato',
      disabledUploadEditDoc: true,
      waitUploadEditDoc: false,

      selectedSignerByRevision: {},
      signerKeyCounter: 0,

      newRevisionExpireWarning: false,

      waitAddRevisionLog: false
    }
  },

  computed: {
    getRceeYears() {
      let response = {}

      this.codes.forEach(code => {
        response[code] = rcee.calcRcee(this.implant, code)
      })

      response['_nocode'] = rcee.calcRcee(this.implant, false)

      return response
    },

    operatorsWithSignature() {
      return (this.$store.getters.operators || []).filter(operator => !!operator.signature_url)
    }
  },

  methods: {
    ensureSignerPreselection() {
      const enabledOperators = this.operatorsWithSignature || []

      let defaultSigner = null
      if (enabledOperators.length === 1) {
        defaultSigner = enabledOperators[0]
      } else if (enabledOperators.length > 1) {
        const currentUserId = this.$store.state.user?._id
        if (currentUserId) {
          defaultSigner = enabledOperators.find(operator => operator._id === currentUserId) || null
        }
      }

      ;(this.revisions || []).forEach(revision => {
        const signerKey = this.getSignerKey(revision)
        const selectedSigner = this.selectedSignerByRevision[signerKey]
        const isSelectedSignerEnabled = !!enabledOperators.find(operator => operator._id === selectedSigner?._id)

        if (!selectedSigner || !isSelectedSignerEnabled) {
          if (defaultSigner) {
            this.selectedSignerByRevision[signerKey] = defaultSigner
          } else {
            delete this.selectedSignerByRevision[signerKey]
          }
        }
      })
    },

    getRecordKey(record) {
      if (!record || typeof record !== 'object') {
        return 'invalid-record'
      }

      if (!this.revisionLogKeys.has(record)) {
        this.revisionLogKeyCounter += 1
        this.revisionLogKeys.set(record, 'log-' + this.revisionLogKeyCounter)
      }

      return this.revisionLogKeys.get(record)
    },

    parseLogDate(dateValue) {
      if (!dateValue) {
        return null
      }

      const date = new Date(dateValue)
      if (Number.isNaN(date.getTime())) {
        return null
      }

      return date
    },

    isDifferenceLessThanOneYear(firstDateValue, secondDateValue) {
      const firstDate = this.parseLogDate(firstDateValue)
      const secondDate = this.parseLogDate(secondDateValue)
      if (!firstDate || !secondDate) {
        return false
      }

      const minDate = firstDate <= secondDate ? firstDate : secondDate
      const maxDate = firstDate <= secondDate ? secondDate : firstDate

      const minDatePlusOneYear = new Date(minDate)
      minDatePlusOneYear.setFullYear(minDatePlusOneYear.getFullYear() + 1)

      return maxDate < minDatePlusOneYear
    },

    setRevisionPreviousExpire(revision) {
      if (!revision || typeof revision !== 'object') {
        return
      }

      revision._previousExpire = revision.expire || ''
      revision._showExpireWarning = false
    },

    onRevisionExpireChange(revision) {
      if (!revision || typeof revision !== 'object') {
        return
      }

      const previousExpire = revision._previousExpire
      const nextExpire = revision.expire

      revision._showExpireWarning = this.isDifferenceLessThanOneYear(previousExpire, nextExpire)

      delete revision._previousExpire
    },

    sortRevisionLog(log = []) {
      return log.toSorted((a, b) => {
        const dateA = this.parseLogDate(a?.date)
        const dateB = this.parseLogDate(b?.date)

        // Records without date stay on top.
        if (!dateA && !dateB) {
          return 0
        }
        if (!dateA) {
          return -1
        }
        if (!dateB) {
          return 1
        }

        // Most recent first.
        return dateB - dateA
      })
    },

    deleteRevisionLog(revision, record) {
      if (!Array.isArray(revision?.log)) {
        return
      }

      const recordIndex = revision.log.indexOf(record)
      if (recordIndex !== -1) {
        revision.log.splice(recordIndex, 1)
      }
    },

    addRevision() {
      let code = null
      if (this.codes?.length === 1) {
        code = this.codes[0]
      }

      this.revisions.push({
        name: '',
        expire: new Date().toDateInputValue(),
        code
      })
    },

    openModalRevisionLog(index) {
      this.newRevisionLog.date = this.operation?.appointment_date || ''
      this.newRevisionLog.price = null
      this.newRevisionLog.paid = false
      this.newRevisionLog.rcee = false
      this.newRevisionLog.notes = ''
      this.newRevisionLog.docs = []
      this.newRevisionLog.index = index
      this.newRevisionExpireWarning = false

      const selectedRevision = this.revisions[this.newRevisionLog.index]

      this.newRevisionLog.newExpire = this.calcRevisionExpireDate(selectedRevision, this.newRevisionLog.date)

      //calculate rcee
      const rceeByCode = this.getRceeYears[selectedRevision.code] || this.getRceeYears['_nocode']
      if (rceeByCode && !rceeByCode.error) {
        const years = rceeByCode.years
        if (years) {
          //find latest rcee log
          const rceeLogs = (selectedRevision.log || []).toSorted((a, b) => new Date(b.date) - new Date(a.date)).filter(log => log.rcee)
          if (rceeLogs?.length) {
            const latest = new Date(rceeLogs[0].date)
            const latestYear = latest.getFullYear()

            const maintenanceDate = this.parseLogDate(this.newRevisionLog.date) || new Date()
            const maintenanceYear = maintenanceDate.getFullYear()

            const diff = maintenanceYear - latestYear
            if (diff >= 0 && diff % years === 0) {
              this.newRevisionLog.rcee = true
            } else {
              this.newRevisionLog.rcee = false
            }
          }
        }
      }

      this.openNewRevisionLog = true

      this.$nextTick(() => {
        this.resetUploadInputs('new')
      })
    },

    calcRevisionExpireDate(revision, baseDateValue) {
      const baseDate = this.parseLogDate(baseDateValue) || this.parseLogDate(revision?.expire)
      if (!baseDate) {
        return ''
      }

      const expire = new Date(baseDate)
      expire.setDate(1)

      const foundType = this.$store.state.revision_types.find(type => type.name === revision?.type)
      const periodMonths = Number(foundType?.months || 0)
      const periodYears = Number(foundType?.years || 0)

      if (periodMonths > 0) {
        expire.setMonth(expire.getMonth() + periodMonths)
      } else if (periodYears > 0) {
        expire.setFullYear(expire.getFullYear() + periodYears)
      } else {
        expire.setFullYear(expire.getFullYear() + 1)
      }

      return expire.toDateInputValue()
    },

    onRevisionLogDateChange() {
      const selectedRevision = this.revisions[this.newRevisionLog.index]
      if (!selectedRevision) {
        return
      }

      this.newRevisionLog.newExpire = this.calcRevisionExpireDate(selectedRevision, this.newRevisionLog.date)
      this.onNewRevisionExpireChange()
    },

    onNewRevisionExpireChange() {
      const selectedRevision = this.revisions[this.newRevisionLog.index]
      if (!selectedRevision) {
        return
      }

      this.newRevisionExpireWarning = this.isDifferenceLessThanOneYear(selectedRevision.expire, this.newRevisionLog.newExpire)
    },

    async addRevisionLog() {
      if (!this.newRevisionLog.date) {
        alert('Inserisci la data manutenzione!')
        return
      }

      this.waitAddRevisionLog = true

      if (!this.revisions[this.newRevisionLog.index].log) {
        this.revisions[this.newRevisionLog.index].log = []
      }

      let docs = []
      const filesToUpload = this.getSelectedFiles('new')
      if (filesToUpload.length) {
        try {
          docs = await this.uploadRevisionDocs(filesToUpload)
        } catch (error) {
          console.log(error)
          alert('Errore caricamento allegati')
          this.waitAddRevisionLog = false
          return
        }
      }

      this.revisions[this.newRevisionLog.index].log.push({
        date: this.newRevisionLog.date,
        price: this.newRevisionLog.price,
        paid: this.newRevisionLog.paid,
        notes: this.newRevisionLog.notes,
        operation: this.operation ? this.operation._id : null,
        rcee: this.newRevisionLog.rcee,
        docs
      })

      if (this.newRevisionLog.newExpire) {
        this.revisions[this.newRevisionLog.index].expire = this.newRevisionLog.newExpire
      }

      this.openNewRevisionLog = false
      this.waitAddRevisionLog = false

      this.$emit('addLog')
    },

    resetUploadInputs(mode) {
      if (mode === 'new') {
        if (this.$refs.inputNewDocs) {
          this.$refs.inputNewDocs.value = ''
        }
        if (this.$refs.inputNewPhotoDocs) {
          this.$refs.inputNewPhotoDocs.value = ''
        }
        this.uploadLabelNewFile = 'Nessun file selezionato'
        this.uploadLabelNewPhoto = 'Nessun file selezionato'
        return
      }

      if (this.$refs.inputEditDocs) {
        this.$refs.inputEditDocs.value = ''
      }
      if (this.$refs.inputEditPhotoDocs) {
        this.$refs.inputEditPhotoDocs.value = ''
      }
      this.uploadLabelEditFile = 'Nessun file selezionato'
      this.uploadLabelEditPhoto = 'Nessun file selezionato'
      this.disabledUploadEditDoc = true
    },

    updateUploadLabel(mode) {
      const docsRef = mode === 'new' ? this.$refs.inputNewDocs : this.$refs.inputEditDocs
      const photoRef = mode === 'new' ? this.$refs.inputNewPhotoDocs : this.$refs.inputEditPhotoDocs

      const docsCount = docsRef?.files?.length || 0
      const photoCount = photoRef?.files?.length || 0
      const total = docsCount + photoCount

      if (mode === 'new') {
        this.uploadLabelNewFile = docsCount === 0 ? 'Nessun file selezionato' : (docsCount + ' file ' + (docsCount > 1 ? 'selezionati' : 'selezionato'))
        this.uploadLabelNewPhoto = photoCount === 0 ? 'Nessun file selezionato' : (photoCount + ' file ' + (photoCount > 1 ? 'selezionati' : 'selezionato'))
        return
      }

      this.uploadLabelEditFile = docsCount === 0 ? 'Nessun file selezionato' : (docsCount + ' file ' + (docsCount > 1 ? 'selezionati' : 'selezionato'))
      this.uploadLabelEditPhoto = photoCount === 0 ? 'Nessun file selezionato' : (photoCount + ' file ' + (photoCount > 1 ? 'selezionati' : 'selezionato'))
      this.disabledUploadEditDoc = total === 0
    },

    getSelectedFiles(mode) {
      const docsRef = mode === 'new' ? this.$refs.inputNewDocs : this.$refs.inputEditDocs
      const photoRef = mode === 'new' ? this.$refs.inputNewPhotoDocs : this.$refs.inputEditPhotoDocs

      return [
        ...Array.from(docsRef?.files || []),
        ...Array.from(photoRef?.files || [])
      ]
    },

    compressFile(file) {
      return new Promise((resolve) => {
        new Compressor(file, {
          quality: 0.7,
          maxWidth: 2400,
          maxHeight: 2400,
          success(result) {
            resolve(result)
          },
          error() {
            resolve(file)
          },
        })
      })
    },

    async uploadRevisionDocs(files) {
      const docs = []

      for (const file of files) {
        const compressedFile = await this.compressFile(file)
        const formData = new FormData()
        formData.append('file', compressedFile, compressedFile.name)

        const response = await this.$http.post('/revision/doc', formData)
        if (Array.isArray(response?.data?.docs) && response.data.docs.length) {
          docs.push(...response.data.docs)
        }
      }

      return docs
    },

    ensureRecordDocs(record) {
      if (!Array.isArray(record.docs)) {
        record.docs = []
      }
    },

    openEditDocModal(record) {
      this.editRecord = record
      this.ensureRecordDocs(this.editRecord)
      this.openEditRevisionDocs = true

      this.$nextTick(() => {
        this.resetUploadInputs('edit')
      })
    },

    async uploadEditDocs() {
      const filesToUpload = this.getSelectedFiles('edit')
      if (!filesToUpload.length) {
        return
      }

      this.waitUploadEditDoc = true
      try {
        const docs = await this.uploadRevisionDocs(filesToUpload)
        this.ensureRecordDocs(this.editRecord)
        this.editRecord.docs.push(...docs)
        this.resetUploadInputs('edit')
      } catch (error) {
        console.log(error)
        alert('Errore caricamento allegati')
      }
      this.waitUploadEditDoc = false
    },

    async deleteDoc(record, docIndex) {
      if (!Array.isArray(record?.docs) || !record.docs[docIndex]) {
        return
      }
      if (!confirm('Eliminare allegato?')) {
        return
      }

      const doc = record.docs[docIndex]
      try {
        if (doc.url) {
          await this.$http.delete('/revision/doc/' + doc.url)
        }
      } catch (error) {
        console.log(error)
      }

      record.docs.splice(docIndex, 1)
    },

    editDocName(doc) {
      const nextName = prompt('Inserisci il nuovo nome del file', doc.name || doc.url)
      if (nextName !== null) {
        doc.name = nextName
      }
    },

    formatDocUser(doc) {
      if (doc?.createdByName) {
        return doc.createdByName
      }

      if (doc?.createdBy && typeof doc.createdBy === 'object') {
        const name = [doc.createdBy.name, doc.createdBy.surname].filter(Boolean).join(' ').trim()
        if (name) {
          return name
        }
        if (doc.createdBy.email) {
          return doc.createdBy.email
        }
      }

      return '-'
    },

    onResize() {
      this.isMobile = window.innerWidth < 900
    },

    calcNextRcee(revision) {
      return rcee.calcNextRcee(this.implant, revision)
    },

    openDoc(revision, type, query = {}) {
      const signer = this.selectedSignerByRevision[this.getSignerKey(revision)]
      const params = Object.assign({}, query)
      if (signer?._id) {
        params.signerId = signer._id
      }

      this.$http.get('/file/template/' + this.operation._id + '/' + this.implant._id + '/' + revision.code + '/' + type, { params }).then(response => {
        const url = response.data.url
        window.location = url

        //self.waitFinalReport = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        //self.waitFinalReport = false
      })
    },

    async openDocPerThermalGroup(revision, type = 'rcee_gt_bollino') {
      const thermalGroups = this.getThermalGroupsByCode(revision.code)
      if (!thermalGroups.length) {
        return
      }

      const errors = []

      for (const group of thermalGroups) {
        try {
          const signer = this.selectedSignerByRevision[this.getSignerKey(revision)]
          const params = { thermalId: group._id }
          if (signer?._id) {
            params.signerId = signer._id
          }

          const response = await this.$http.get('/file/template/' + this.operation._id + '/' + this.implant._id + '/' + revision.code + '/' + type, {
            params
          })

          if (response?.data?.url) {
            const link = document.createElement('a')
            link.href = response.data.url
            link.target = '_blank'
            link.rel = 'noopener'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        } catch (error) {
          console.log(error)
          errors.push(group.number || group._id)
        }
      }

      if (errors.length) {
        alert('Errore generazione RCEE per alcuni gruppi termici: ' + errors.join(', '))
      }
    },

    async openDocPerPumpGroup(revision) {
      const pumpGroups = this.getPumpGroupsByCode(revision.code)
      if (!pumpGroups.length) {
        return
      }

      const errors = []

      for (const group of pumpGroups) {
        try {
          const signer = this.selectedSignerByRevision[this.getSignerKey(revision)]
          const params = { pumpId: group._id }
          if (signer?._id) {
            params.signerId = signer._id
          }

          const response = await this.$http.get('/file/template/' + this.operation._id + '/' + this.implant._id + '/' + revision.code + '/rcee_gf', {
            params
          })

          if (response?.data?.url) {
            const link = document.createElement('a')
            link.href = response.data.url
            link.target = '_blank'
            link.rel = 'noopener'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        } catch (error) {
          console.log(error)
          errors.push(group.number || group._id)
        }
      }

      if (errors.length) {
        alert('Errore generazione RCEE per alcuni gruppi frigo: ' + errors.join(', '))
      }
    },

    getThermalGroupsByCode(code) {
      return (this.implant.generator_thermals || []).filter(gen => gen.code === code && !gen.archived)
    },

    getPumpGroupsByCode(code) {
      return (this.implant.generator_pumps || []).filter(gen => gen.code === code && !gen.archived)
    },

    hasMultipleThermalGroups(code) {
      return this.getThermalGroupsByCode(code).length > 1
    },

    hasMultiplePumpGroups(code) {
      return this.getPumpGroupsByCode(code).length > 1
    },

    isGt(code) {
      return this.implant.generator_thermals?.some(gen => gen.code === code)
    },

    isGf(code) {
      return this.implant.generator_pumps?.some(gen => gen.code === code)
    },

    getSignerKey(revision) {
      if (!revision || typeof revision !== 'object') {
        return 'revision-default'
      }

      if (revision._id) {
        return revision._id
      }

      if (!revision._signerKey) {
        this.signerKeyCounter += 1
        revision._signerKey = 'rev-signer-' + this.signerKeyCounter
      }

      return revision._signerKey
    }
  },

  watch: {
    revisions: {
      deep: true,
      handler() {
        this.ensureSignerPreselection()
      }
    },

    operatorsWithSignature() {
      this.ensureSignerPreselection()
    }
  },

  mounted() {
    this.ensureSignerPreselection()
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>